export default __webpack_public_path__ + "static/media/91631FAA-59CB-40D9-8998-42FB59A922B3_1_105_c.f99bbab0.jpg";